/*
 * @Author: your name
 * @Date: 2019-12-12 14:17:27
 * @LastEditTime: 2019-12-13 15:12:29
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ControlPanel\src\router\modules\product.js
 */
export default {
	name: 'product-operation',
	path: '/product-operation',
	redirect: '/product-operation/knowledge-payment',
	meta: {
		title: 'product_operation',
		icon: 'icon-product-operation'
	},
	children: [
		{
			name: 'knowledge-payment',
			path: 'knowledge-payment',
			redirect: '/product-operation/knowledge-payment/live-room',
			fullPath: '/product-operation/knowledge-payment',
			meta: {
				title: 'knowledge_payment',
				icon: 'icon-knowledge-payment'
			},
			component: () =>
				import(/*webpackChunkName: "knowledge-payment"*/ '@/views/product-operation/knowledge-payment'),
			children: [
				{
					name: 'live-room',
					path: 'live-room',
					fullPath: '/product-operation/knowledge-payment/live-room',
					meta: {
						title: '直播间',
						icon: 'icon-live-room'
					},
					component: () =>
						import(/*webpackChunkName: "live-room"*/ '@/views/product-operation/knowledge-payment/live-room')
				},
				{
					name: 'members',
					path: 'members',
					fullPath: '/product-operation/knowledge-payment/members',
					meta: {
						title: '开通会员',
						icon: 'icon-members'
					},
					component: () =>
						import(/*webpackChunkName: "live-room"*/ '@/views/product-operation/knowledge-payment/members')
				}
			]
		},
		{
			name: 'news-center',
			path: 'news-center',
			fullPath: '/product-operation/news-center',
			meta: {
				title: '消息中心',
				icon: 'icon-news-center',
				keepAlive: false
			},
			component: () =>
				import(/*webpackChunkName: "news-center"*/ '@/views/product-operation/news-center')
		},
		{
			name: 'news-addNews',
			path: 'addNews',
			fullPath: '/product-operation/news-center',
			meta: {
				title: '添加消息',
				keepAlive: false
			},
			component: () =>
				import(/*webpackChunkName: "news-center"*/ '@/views/product-operation/news-center/add-news')
		},
		{
			name: 'news-edit',
			path: 'editNews',
			fullPath: '/product-operation/news-center',
			meta: {
				title: '编辑消息',
				keepAlive: false
			},
			component: () =>
				import(/*webpackChunkName: "news-center"*/ '@/views/product-operation/news-center/edit-news')
		},
		// 学校数据导出
		{
			name: 'school-export',
			path: 'school-export',
			fullPath: '/product-operation/school-export',
			// redirect: '/product-operation/school-export',
			meta: {
				title: '学校数据导出',
				keepAlive: false
			},
			component: () =>
				import(/*webpackChunkName: "monitor-management"*/ '@/views/product-operation/school-export/index.vue')
		}
	]
};
